/*
 * @Author: yuanjianlong
 * @Description: 路由配置
 * @Date: 2021-07-26 16:27:34
 * @LastEditTime: 2024-09-21 00:21:47
 * @LastEditTime: 2022-03-07 10:25:04
 * @LastEditTime: 2022-02-21 11:36:58
 * @FilePath: /teacher-h5/src/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import storage from '@/utils/storage.js'
import service from '../service'
import * as Sentry from '@sentry/browser'
import { getToken } from '@/utils/tools'
// const _ = require('lodash')
import store from '@/store'
// import { EventBus } from '@/views/studentManage/studentAndGroup/studentDetails/event-bus'
import { getStudentRight } from '@/utils/menuTool'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const DemoCommon = () => import('../demo/index.vue')
const Button = () => import('../demo/Button.vue')
const Input = () => import('../demo/input.vue')
const Form = () => import('../demo/form.vue')
const Checkbox = () => import('../demo/checkbox.vue')
const Radio = () => import('../demo/radio.vue')
const Modal = () => import('../demo/modal.vue')
const Message = () => import('../demo/message.vue')
const Pagination = () => import('../demo/pagination.vue')
const Switch = () => import('../demo/switch.vue')
const Breadcrumb = () => import('../demo/breadcrumb.vue')
const Audio = () => import('../demo/audio.vue')
const Answer = () => import('../demo/answer.vue')
const Video = () => import('../demo/video.vue')
const Courseware = () => import('../demo/courseware.vue')
const Icons = () => import('../demo/icons.vue')
const Gaopin = () => import('../demo/gaopin.vue')

const Login = () => import('@/views/login')
const Entry = () => import('@/views/entry')

const GroupList = () => import('@/views/groupManage/groupList/index')
// 课程与小组
const CourseAndGroup = () => import('@/views/courseAndGroup/index')
const CourseAndCorrect = () => import('@/views/courseAndCorrect/index')
const CheckDetailsPage = () => import('@/views/inClass/checkDetailsPage/index')
const CheckTool = () => import('@/views/checkTool/index')
const CheckTool2 = () => import('@/views/checkTool/index2')

// 监课看板
const Supervision = () => import('@/views/supervision/index')
// 学情看板
const LearningSituationList = () => import('@/views/learningSituation/index')
// 学生权益包管理
const StudentRightsList = () => import('@/views/StudentRights/index')
// 学生权益包获取记录
const rightLog = () => import('@/views/StudentRights/rightLog/index')
// 金币扣减
const GoldList = () => import('@/views/gold/index')
// 查看课程
const ScanVideo = () => import('@/views/courseAndCorrect/scanVideo.vue')

// 路由访问精准学页面
const InJzxCommonPage = () => import('@/components/InJzxTool/index')
// 路由访问精准学页面
const InJzxSecondPagePage = () => import('@/components/InJzxTool/secondPage.vue')
// const Template = {
//   template: '<router-view></router-view>'
// }

const isProduction = process.env.NODE_ENV == 'production'

const commonRoute = [
  {
    path: '/',
    redirect: {
      name: 'classList'
    }
  },
  {
    path: '/index',
    redirect: {
      name: 'classList'
    }
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: Login
  },
  {
    path: '/inJzxCommonPage',
    name: 'inJzxCommonPage',
    meta: { title: '引入精准学页面' },
    component: InJzxCommonPage
  },
  {
    path: '/InJzxSecondPagePage',
    name: 'InJzxSecondPagePage',
    meta: { title: '引入精准学页面' },
    component: InJzxSecondPagePage
  },
  // 小组与学员
  {
    path: '/groupManage',
    name: 'groupManage',
    component: Entry,
    redirect: {
      name: 'groupList'
    },
    children: [
      {
        path: 'groupList',
        name: 'groupList',
        meta: {
          title: '小组与学员'
        },
        component: GroupList
      }
    ]
  },
  // 课程与学员
  {
    path: '/courseAndGroup',
    name: 'courseAndGroup',
    redirect: {
      name: 'list'
    },
    component: Entry,
    children: [
      {
        path: 'list',
        name: 'list',
        meta: {
          title: '课程与小组'
        },
        component: CourseAndGroup
      }
    ]
  },
  // 监课看板
  {
    path: '/supervisionCourse',
    name: 'supervisionCourse',
    redirect: {
      name: 'supervisionList'
    },
    component: Entry,
    children: [
      {
        path: 'list',
        name: 'supervisionList',
        meta: {
          title: '监课看板'
        },
        component: Supervision
      }
    ]
  },
  {
    path: '/learningSituation',
    name: 'LearningSituation',
    redirect: {
      name: 'LearningSituationList'
    },
    component: Entry,
    children: [
      {
        path: 'list',
        name: 'LearningSituationList',
        meta: {
          title: '学情看板'
        },
        component: LearningSituationList
      }
    ]
  },
  {
    path: '/gold',
    name: 'gold',
    redirect: {
      name: 'Gold'
    },
    component: Entry,
    children: [
      {
        path: 'list',
        name: 'GoldList',
        meta: {
          title: '金币增减'
        },
        component: GoldList
      }
    ]
  },
  // 上课与批改
  {
    path: '/inClass',
    name: 'inClass',
    redirect: {
      name: 'classList'
    },
    component: Entry,
    children: [
      {
        path: 'classList',
        name: 'classList',
        meta: {
          title: '上课与批改',
          keepAlive: true
        },
        component: CourseAndCorrect
      },
      {
        path: 'checkDetailsPage',
        name: 'checkDetailsPage',
        component: CheckDetailsPage,
        meta: {
          title: '批改详情页'
        }
      },
      // 批改
      {
        path: 'checktool',
        name: 'checktool',
        component: CheckTool,
        meta: {
          title: '批改'
        }
      },
      {
        path: 'checktool2',
        name: 'checktool2',
        component: CheckTool2,
        meta: {
          title: '批改'
        }
      },
      {
        path: 'scanVideo',
        name: 'scanVideo',
        component: ScanVideo,
        meta: {
          title: '查看课程'
        }
      },
      // 授课
      {
        path: 'giveInstruction',
        name: 'giveInstruction',
        meta: {
          hideMenu: true,
          hideBreadcrumb: true,
          hideHeader: 1
        },
        component: () => import('@/views/giveInstruction')
      }
    ]
  },
  {
    path: '/studentRights',
    name: 'StudentRights',
    redirect: {
      name: 'StudentRightsList'
    },
    component: Entry,
    children: [
      {
        path: 'list',
        name: 'StudentRightsList',
        meta: {
          title: '学生权益包管理'
        },
        component: StudentRightsList
      },
      {
        path: 'rightLog',
        name: 'rightLog',
        component: rightLog,
        meta: {
          title: '权益获取记录'
        }
      }
    ]
  },
  {
    path: '/permission',
    name: 'permission',
    redirect: {
      name: 'permissionError'
    },
    component: Entry,
    children: [
      {
        path: 'permissionError',
        name: 'permissionError',
        meta: {
          title: '权限异常',
          hideMenu: true,
          hideBreadcrumb: true
        },
        component: () => import('@/views/permission')
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/views/error'),
    hidden: true
  }
]

// 开发环境
if (!isProduction) {
  commonRoute.push({
    path: '/demo',
    name: 'demo',
    meta: { title: 'demo' },
    component: DemoCommon,
    children: [
      {
        path: 'button',
        name: 'button',
        meta: { title: '组件-按钮' },
        component: Button
      },
      {
        path: 'input',
        name: 'input',
        meta: { title: '组件-输入框' },
        component: Input
      },
      {
        path: 'form',
        name: 'form',
        meta: { title: '组件-表单' },
        component: Form
      },
      {
        path: 'checkbox',
        name: 'checkbox',
        meta: { title: '组件-多选框' },
        component: Checkbox
      },
      {
        path: 'radio',
        name: 'radio',
        meta: { title: '组件-单选框' },
        component: Radio
      },
      {
        path: 'modal',
        name: 'modal',
        meta: { title: '组件- ' },
        component: Modal
      },
      {
        path: 'message',
        name: 'message',
        meta: { title: '组件-全局提示' },
        component: Message
      },
      {
        path: 'pagination',
        name: 'pagination',
        meta: { title: 'Pagination 分页' },
        component: Pagination
      },
      {
        path: 'switch',
        name: 'switch',
        meta: { title: 'Switch 开关' },
        component: Switch
      },
      {
        path: 'breadcrumb',
        name: 'breadcrumb',
        meta: { title: 'Breadcrumb 面包屑' },
        component: Breadcrumb
      },
      {
        path: 'audio',
        name: 'audio',
        meta: { title: '语音点评' },
        component: Audio
      },
      {
        path: 'answer',
        name: 'answer',
        meta: { title: '答案' },
        component: Answer
      },
      {
        path: 'courseware',
        name: 'courseware',
        meta: { title: '在线课件' },
        component: Courseware
      },
      {
        path: 'video',
        name: 'video',
        meta: { title: '视频' },
        component: Video
      },
      {
        path: 'icons',
        name: 'icons',
        meta: { title: 'icons' },
        component: Icons
      },
      {
        path: 'gaopin',
        name: 'gaopin',
        meta: { title: 'gaopin' },
        component: Gaopin
      }
    ]
  })
  commonRoute.push({
    path: '/video',
    name: 'Video',
    component: () => import('@/views/video'),
    hidden: true
  })
}
const routes = [...commonRoute]
const createRouter = () => new VueRouter({
  base: '/',
  mode: 'history', // history模式用于预渲染
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const router = createRouter()

// 用户信息获取
const getLoginInfo = async function () {
  const info = store.state.userInfo.userInfo
  const stringifyInfo = JSON.stringify(info)
  if (!info || stringifyInfo === '{}') {
    store.commit('common/setGlobalSpinning', true)
    // 获取用户是否有【学员权益包管理权限】，没有则不展示对应菜单
    const userInfo = await service.login.getLogininfo()
    store.commit('userInfo/setUserInfo', userInfo)
    store.commit('common/setGlobalSpinning', false)
  }
}

const getBaseData = async function () {
  const bData = store.state.common.baseData
  const stringifyBData = JSON.stringify(bData)
  if (!bData || stringifyBData === '{}') {
    store.commit('common/setGlobalSpinning', true)
    const baseData = await service.common.getBaseData()
    if (baseData) {
      store.commit('common/setBaseData', baseData)
      store.commit('common/setPeriodList', baseData.period)
      store.commit('common/setClassCycleList', baseData.classCycle)
      store.commit('common/setYearList', baseData.year)
      store.commit('common/setTimeIntervalList', baseData.timeInterval)
      store.commit('common/setSemesterList', baseData.semester)
      store.commit('common/setLinkTypeList', baseData.linkType)
      store.commit('common/setGroupStudentTypeList', baseData.groupStudentType)
      store.commit('common/setTeacherOperateTypeList', baseData.teacherOperateType)
      store.commit('common/setClassCorrectTypeList', baseData.classCorrectType)
      store.commit('common/setClassCorrectOptTypeList', baseData.classCorrectOptType)
      store.commit('common/setJurisdictionType', baseData.jurisdictionType)
    }
    store.commit('common/setGlobalSpinning', false)
  }
}
const getGroupMsg = async function () {
  try {
    const res = await service.common.clashQuery()
    if (Array.isArray(res)) {
      store.commit('common/setGroupMsgArr', res)
    }
  } catch (err) {
    throw new Error(err)
  }
}

const beforeNext = function () {
  return Promise.all([getLoginInfo(), getBaseData()])
}

// 路由守卫
router.beforeEach(beforeEach)
router.afterEach(afterEach)

async function beforeEach(to, from, next) {
  store.commit('common/setGlobalSpinning', false)
  const token = getToken()
  // setWmUserInfo()
  if (!token && to.name !== 'login') { // 未登录并且不是在登录页
    next({ path: '/login' })
  } else {
    if (token) {
      await beforeNext()
      getGroupMsg()
    }
    if (to.path === '/studentRights/list') { // 学员权益包路由单独处理
      const showRightMenu = getStudentRight()
      if (showRightMenu) { // 学员权益包管理权限
        next()
      } else {
        next({ path: '/' })
      }
    }
    if (store.getters['userInfo/userInfo']?.gddHide) {
      // , '/gold/list'
      if (['/studentRights/list'].includes(to.path)) {
        next({ path: '/' })
        return
      }
    }
    if (token && to.name === 'login') { // 在登录页，已经登录跳转到首页
      next({ path: '/index' })
    } else {
      next()
    }
  }
}

// 对接webfunny
// function setWmUserInfo() {
//   const userId = getUserId() || -1
//   window.localStorage.wmUserInfo = JSON.stringify({ userId, projectVersion: '1.0.1', env: window.__ENV__ === 'production' ? 'pro' : 'dev' })
// }
function afterEach(to) {
  const { store } = router.app.$options
  const { userInfo } = store.state.userInfo || {}
  // 当有用户信息时给 sentry 设置用户信息
  Sentry.setUser({ ...userInfo, username: userInfo.teacherName || '未登录' })
  // document.querySelector('#app').scrollTo(0, 0)
}
export default router
